let _ = require('../_.js');
let $ = jQuery;

// Like click_pleasewait, but for submit events
$.fn.submit_pleasewait = function (fn) {
    let $that = this;
    this.on("submit", function (e) {
        console.warn("SUBMIT");
        e.preventDefault();

        (async function () {

            let $submit = $that.find(".submit-btn-pleasewait");

            if (!$submit.length) {
                console.warn("There should be a submit-btn-pleasewait class on a button for submit_pleasewait to work");
                return;
            }

            $submit.blur();

            // If element already has 'async-please-wait' class, do not proceed
            if ($submit.hasClass('ac-async-pleasewait')) {
                return;
            }

            $submit.addClass('ac-async-pleasewait');

            try {
                await fn.bind($that)(e);
            } catch (error) {
                console.error(error);
            } finally {
                $submit.removeClass('ac-async-pleasewait');
            }
        })();

    });
};



/**
 * Initializes and handles user interactions with the phone verification digit input fields.
 *
 * This function has several responsibilities:
 * 1. It allows the user to input digits from a phone verification code into each textbox, one digit per box.
 * 2. The focus automatically moves to the next box after a digit is entered. If the final textbox is filled, the focus remains on it.
 * 3. When the user attempts to delete a digit, the focus automatically moves to the previous box. All subsequent boxes to the right are also cleared.
 * 4. When pasting a string into a textbox, the function will spread the digits across the remaining boxes, and moves the focus to the last filled textbox or the last textbox if all are filled.
 * 5. It disables the form submit button until all boxes are filled with digits, and enables it when they are. The button's CSS class also changes to reflect this status.
 * 6. It triggers form submission when the user presses the Enter key with all boxes filled.
 * 7. It clears all boxes to the right when a box is cleared.
 * 8. It moves focus to the first empty box if a filled box or the submit button is clicked.
 * 9. When a textbox that contains a digit gains focus, the focus will move to the end of the input.
 * 10. If the form is reset, it will clear all the textboxes and reset the form state.
 * 11. It finds an input field with name='thedigits' on the form, and fills it in with the 6 digits as they are entered into the inputs.
 */
_.on_ui_update_once('.digit-verify-component', function () {
    let $component = $(this);
    let manualFocus = false;

    $component.find(".digit-input").on("keydown", function (e) {
        if (e.key === "Backspace" || e.key === "Delete") {
            $(this).val("");
            $(this).nextAll(".digit-input").val("");
            resetForm();
            $(this).prev(".digit-input").focus();
            return false;
        } else if (e.key === "Enter") {
            e.preventDefault();
            if (checkComplete()) {
                $component.closest("form").submit();
            }
        }
        updateDigits();
    });

    $component.find(".digit-input").on("input", function (e) {
        const input = $(this).val();
        const cleanedInput = input.replace(/\D/g, '');
        $(this).val(cleanedInput.substring(0, 1));

        const nextDigits = cleanedInput.substring(1);
        let next = $(this).next(".digit-input");
        for (let i = 0; i < nextDigits.length && next.length > 0; i++) {
            next.val(nextDigits[i]);
            next = next.next(".digit-input");
        }

        manualFocus = true;
        if (next.length > 0) {
            next.focus();
        }
        manualFocus = false;

        checkComplete();
        updateDigits();
    });

    $component.find(".digit-input").on("focus", function (e) {
        if (!manualFocus) {
            const el = $(this);
            if (el.val() !== "") {
                setTimeout(function () {
                    el[0].setSelectionRange(1, 1);
                }, 0);
            } else {
                manualFocus = true;
                el.prevAll(".digit-input").addBack().each(function (i, el) {
                    if ($(el).val() == "") {
                        $(el).focus();
                        manualFocus = false;
                        return false;
                    }
                });
            }
        }
    });

    function resetForm() {
        $component.find(".digit-input").val("");
        $component.closest("form").find(":submit").addClass('btn-secondary').removeClass('btn-success').prop("disabled", true).css('cursor', 'not-allowed');
    }

    function checkComplete() {
        let allFilled = $component.find(".digit-input").get().every(function (el) {
            return $(el).val() !== "";
        });
        let $button = $component.closest("form").find(":submit");
        if (allFilled) {
            $button.removeClass('btn-secondary').addClass('btn-success').prop("disabled", false).css('cursor', '');
        } else {
            $button.removeClass('btn-success').addClass('btn-secondary').prop("disabled", true).css('cursor', 'not-allowed');
        }
    }

    function updateDigits() {
        const digits = $component.find(".digit-input").map(function () { return $(this).val(); }).get().join("");
        $component.closest("form").find("input[name='thedigits']").val(digits);
    }

    $component.closest("form").on("reset", function () {
        resetForm();
        updateDigits();
    });

    resetForm();
    updateDigits();
});




_.on_ui_update_once(".confirm-link-if-changes", function () {
    var formChanged = false;

    // Event handler for form input change
    $('form :input').not(':submit').on('input', function () {
        formChanged = true;
    });

    $(this).click(function (e) {
        if (formChanged) {
            if (!confirm("Leave without saving changes?")) {
                e.preventDefault();
            }
        }
    });
})

// Shows the dropdown which is passed as an argument below the selected anchor element
$.fn.show_dropdown = function ($dropdown, top_margin = 0) {
    let $anchor = this;

    $dropdown.hide();

    $('body').append($dropdown);

    $dropdown.css({
        position: "absolute",
        top: ($anchor.offset().top + $anchor.outerHeight() + top_margin) + "px",
        left: ($anchor.offset().left) + "px"
    });

    $dropdown.fadeIn(300);
};

// Helper for dropdowns to close dropdown
$(document).click(function (event) {
    if (!$(event.target).closest('.dropdown-menu').length) {
        $('.dropdown-menu:visible').fadeOut(300);
    }
});
$(document).keydown(function (event) {
    if (event.keyCode == 27) { //escape
        $('.dropdown-menu:visible').fadeOut(300);
    }
});

// playVideoJS - plays a video on selected element.  Call $().
$.fn.extend({
    video_js: function (videoURL) {
        // The selected element
        var $element = $(this);

        $element.video_js_dispose();

        var id = $element.attr('id')
        if (!id) {
            id = 'videojs-' + Math.floor(Math.random() * 1000000);;
            $element.attr('id', id);
        }

        console.warn("VJS");
        // Initialize the video element with videojs
        player = videojs(id, {
            controls: true,
            autoplay: true,
            preload: 'auto',
            sources: [{
                src: videoURL,
                type: 'video/mp4'
            }]
        }, function () {
            // Video.js player is ready
            this.play();
        });
    }, video_js_dispose: function (videoURL) {
        // The selected element
        var $element = $(this);

        // Get the id of the video element or assign a random id if it doesn't exist
        var id = $element.attr('id')
        if (!id) {
            id = 'videojs-' + Math.floor(Math.random() * 1000000);;
            $element.attr('id', id);
        }

        // Check if the videojs instance already exists
        var player = videojs.getPlayer(id);

        // If it does, dispose of it
        if (player) {
            player.dispose();
        }
    }
});

// Make the value pop for a moment, to show it changed
$.fn.popValue = async function (show_time = 2000, fade_speed = 500) {
    var $this = $(this);

    if ($this.data("_animatingPopValue")) {
        return;
    }

    $this.data("_animatingPopValue", true);

    // Check if the original styles are saved, if not, save them
    if (!$this.data("originalStyles")) {
        var originalStyles = {
            shadow: $this.css("text-shadow"),
            transition: $this.css("transition"),
            weight: $this.css("font-weight")
        };
        $this.data("originalStyles", originalStyles);
    } else {
        var originalStyles = $this.data("originalStyles");
    }

    // Apply temporary styling to make the element 'pop'
    $this.css({
        "font-weight": "bold",
        "text-shadow": "3px 3px 6px rgb(10, 252, 4)"
    });

    await _.sleep(show_time - 100);

    $this.css({ 'transition': 'all ' + (fade_speed / 1000) + 's' });

    await _.sleep(100);

    // Revert to original styles
    $this.css({
        "text-shadow": originalStyles.shadow,
        "font-weight": originalStyles.weight,
    });

    await _.sleep(fade_speed);

    $this.css({ 'transition': originalStyles.transition });

    $this.data("_animatingPopValue", false);
};
